import http, { getBase, url as buildUrl } from '../http'
const API_URL = "sg-sst"

class SGSSTAPI {

  async createSg_sst(sg_sst) {
    const response = await http(`${API_URL}/save`, 'POST', sg_sst)
    return response
  }

  // type: 'responsable-sg' (acta del profesional) | 'responsable-operativo' (acta del operativo)
  pdfUrl(id, type = 'responsable-sg') {
    return buildUrl(`${API_URL}/${id}/pdf/${type}`)
  }

  async sign(id, type = 'responsable-sg', payload) {
    return await http(`${API_URL}/${id}/sign/${type}`, 'POST', payload)
  }

  async getSGSSTbyCompany(id, page) {
    const response = await http(`${API_URL}/${id}?page=${page}` )
    return response || null
  } 
 
  async getSg_sst(sg_sst) {
    const response = await http(`${API_URL}/show/${sg_sst}`)
    return response
  }

  async updateSg_sst(id, sg_sst) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', sg_sst)
    return response
  }

  async getSSSSTbyID(id) {
    const response = await http(`${API_URL}/showId/${id}`)
    return response
  }

  async getLogsSGSSTbyCompany(id, page) {
    const response = await http(`sgsst-log/show/${id}?page=${page}`)
    return response
  } 

  async saveScore(companyID, company_classification_id, puntation_relative, puntation_absoluta,  items_id ) {
    const response = await http(`${API_URL}/calification/123`, 'PUT', {
     
      companies_id: companyID,
      company_classification_id: company_classification_id,
      puntation_relative : puntation_relative,
      puntation_absoluta : puntation_absoluta,
      items_id : items_id,
    })
    return response
  }

  async updateScore(id, companyID, status) {
    const response = await http(`${API_URL}/calification/edit/${id}`, 'POST', {
      companies_id: companyID,
      status: status
    })
    return response
  }
   
}

export default new SGSSTAPI()